import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import de from "~/lang/de.json";
import en from "~/lang/en.json";

const fallbackResources = {
  en,
  de,
};

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    lng: "de",
    fallbackLng: "de",
    interpolation: {
      escapeValue: false,
      prefix: "{",
      suffix: "}",
    },
    backend: {
      backends: [resourcesToBackend(fallbackResources)],
    },
  });

i18n.services.formatter?.add("titlecase", (value: string) => {
  return value.replace(/\w\S*/g, function (value: string) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  });
});

i18n.services.formatter?.add("translate", (value: string) => {
  type MappedValue = { [key: string]: { [key: string]: string } };

  const mapping: MappedValue = {
    de: {
      oidc: "Soziales Login",
      password: "Passwort",
    },
    en: {
      oidc: "Social login",
      password: "Password",
    },
  };

  const result = mapping[i18n.language]?.[value];
  return result ? result : value;
});

i18n.services.formatter?.add("transform_available_credential_types", (value) => {
  const credential_types = (value?.available_credential_types || []).map((item: string) => {
    return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
  });

  return credential_types.join(",");
})

export default i18n;
